import React from 'react'
import PropTypes from 'prop-types'
import PagesModal from './PagesModal'
import AlertContainer from 'react-alert'
import { listPages } from '../../api/pages'

const LIMIT = 5

class PagesModalContainer extends React.PureComponent {
  alertOptions = {
    offset: 14,
    position: 'top right',
    theme: 'dark',
    time: 5000,
    transition: 'scale'
  }

  constructor (props, context) {
    super(props, context)

    this.state = {
      total: 0,
      pages: [],
      parents: [],
      rows: [],
      currentPage: 1,
      parentId: props.initialParentId
    }
  }

  componentDidMount () {
    this.loadData()
  }

  loadData = async ({ parentId = this.state.parentId, currentPage = this.state.currentPage } = {}) => {
    if (process.env.NODE_ENV === 'test') return

    const offset = (currentPage - 1) * LIMIT
    const filters = {
      fetchPath: true,
      fetchSubPages: true
    }

    if (parentId) {
      filters.parentId = parentId
    }

    try {
      const data = await listPages({offset, limit: LIMIT, filters})
      const totalPages = Math.ceil(data.total / data.limit)
      const pages = Array(totalPages).fill().map((_, i) => i * i)
      const parents = data.rows[0].parents

      this.setState({
        currentPage,
        parentId,
        pages,
        parents,
        ...data
      })
    } catch (err) {
      console.error(err)
      if (err && this.msg) {
        this.msg.show('Unable to retrieve pages', {
          time: 4000,
          type: 'error'
        })
      }
    }
  }

  /*
    Assuming all parents are either in current rows or previous parents
    will build new parents list
   */
  _buildNewParentsList = (parentId = null) => {
    let parents = []
    let pagesById = {}

    if (parentId !== null) {
      // parent should be in either current pages or previous parents
      this.state.parents.map(page => { pagesById[page.id] = page })
      this.state.rows.map(page => { pagesById[page.id] = page })
    }

    while (parentId !== null) {
      let parent = pagesById[parentId]
      parents.unshift(parent)
      parentId = parent.parentId
    }

    return parents
  }

  onChangePage = async (currentPage) => {
    await this.loadData({currentPage})
  }

  onSelect (page) {
    this.toggle()
    this.props.onSelect(page)
  }

  onDrillDown (pageId) {
    this.loadData({parentId: pageId, currentPage: 1})
  }

  toggle = () => {
    this.props.changeModalState(!this.props.isOpen)
  }

  render () {
    const methods = {
      toggle: this.toggle,
      onChange: this.onChange,
      onSelect: this.onSelect,
      prevPage: this.onPrevPage,
      nextPage: this.onNextPage,
      onDrillDown: this.onDrillDown,
      onChangePage: this.onChangePage
    }

    return <div>
      <PagesModal
        this={this}
        isOpen={this.props.isOpen}
        currentPageId={this.props.currentPageId}
        {...methods}
        {...this.state} />
      <AlertContainer ref={a => (this.msg = a)} {...this.alertOptions} />
    </div>
  }
}

PagesModalContainer.propTypes = {
  currentPageId: PropTypes.number,
  initialParentId: PropTypes.number,
  isOpen: PropTypes.bool.isRequired,
  changeModalState: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
}

export default PagesModalContainer



// WEBPACK FOOTER //
// ./src/components/PagesModal/PagesModalContainer.js